/**
 * Suivi « Added to Cart » pour Klaviyo.
 *
 * POURQUOI CE FICHIER EXISTE
 * Le flow « Panier abandonné » se déclenche sur l'événement Added to Cart. Cet
 * événement n'est PAS envoyé par Shopify : c'est au thème de le pousser. Le code
 * qui le faisait a disparu lors d'une refonte, le dernier événement reçu date du
 * 26 janvier 2026. Depuis, le flow est allumé mais ne part jamais.
 *
 * CONTRAT DE DONNÉES, À NE PAS CHANGER SANS TOUCHER AUX MAILS
 * Les quatre mails du flow itèrent sur `event.items` et lisent, sur chaque
 * article, exactement ces six champs :
 *
 *     item.url                 chemin RELATIF, le mail préfixe le domaine
 *     item.image               URL absolue de la vignette
 *     item.product_title
 *     item.variant_title       peut être vide
 *     item.quantity
 *     item.presentment_price   prix UNITAIRE en euros, pas en centimes
 *
 * Relevé le 29/08/2026 sur les gabarits réellement en ligne (S9u2R2, TQfm4M,
 * YuzGvw, W9wLGm), et confirmé deux fois. Envoyer une autre forme ne casse rien
 * de visible : le flow part quand même, avec un panier vide dans le mail.
 */
(function () {
  'use strict';

  if (window.__klaviyoPanierInit) return;
  window.__klaviyoPanierInit = true;

  // Marqueur posé par assets/cart-auto-add.js sur les lignes qu'il ajoute tout
  // seul (sac offert, bébé lutin). Un cadeau qui tombe dans le panier n'est pas
  // un geste du client : le compter déclencherait une relance chez quelqu'un
  // qui n'a rien fait.
  var PROP_AUTO = '_auto_rule';

  var attente = null;

  function pret() {
    return typeof window.klaviyo !== 'undefined' && typeof window.klaviyo.push === 'function';
  }

  // cart.js donne les prix en centimes. Le mail les affiche déjà formatés en
  // euros avec deux décimales, donc la conversion se fait ici, une fois.
  function enEuros(centimes) {
    return Math.round(Number(centimes || 0)) / 100;
  }

  function article(ligne) {
    return {
      url: ligne.url,
      image: ligne.image || (ligne.featured_image && ligne.featured_image.url) || '',
      product_title: ligne.product_title,
      variant_title: ligne.variant_title || '',
      quantity: ligne.quantity,
      presentment_price: enEuros(ligne.final_price)
    };
  }

  function envoyer() {
    if (!pret()) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var lignes = (panier.items || []).filter(function (l) {
          return !(l.properties && l.properties[PROP_AUTO]);
        });
        if (!lignes.length) return;
        window.klaviyo.push(['track', 'Added to Cart', {
          $value: enEuros(panier.total_price),
          items: lignes.map(article)
        }]);
      })
      .catch(function (e) { console.warn('[klaviyo-panier] envoi impossible', e); });
  }

  // Un client qui ajoute trois articles d'affilée ne doit pas produire trois
  // événements : on attend que ça se calme et on envoie l'état final du panier,
  // qui est de toute façon ce que le mail affiche.
  function programmer() {
    clearTimeout(attente);
    attente = setTimeout(envoyer, 900);
  }

  function estAjoutPanier(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // On se branche sur la requête d'ajout plutôt que sur un bouton : le thème
  // ajoute au panier depuis la fiche produit, depuis le tiroir et depuis les
  // blocs d'upsell, avec des boutons tous différents. La requête, elle, est la
  // même partout.
  var fetchOrigine = window.fetch;
  window.fetch = function (entree, options) {
    var url = typeof entree === 'string' ? entree : (entree && entree.url);
    var resultat = fetchOrigine.apply(this, arguments);
    if (estAjoutPanier(url)) {
      resultat.then(function (reponse) {
        if (reponse && reponse.ok) programmer();
      }).catch(function () {});
    }
    return resultat;
  };

  // Repli pour les thèmes ou extensions qui passent encore par XHR.
  var ouvrirOrigine = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    if (estAjoutPanier(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) programmer();
      });
    }
    return ouvrirOrigine.apply(this, arguments);
  };
})();
